import { ProtocolType, StreamItem } from '@/server/services/types'

export const getStreamUris = (stream?: StreamItem[]) => {
  const streamItem = stream?.[0]
  if (!streamItem?.manifests) return { dashUri: undefined, hlsUri: undefined }

  const dashManifest = streamItem.manifests.find(
    (manifest) => manifest.protocol === ProtocolType.Dash,
  )

  const hlsManifest = streamItem.manifests.find(
    (manifest) => manifest.protocol === ProtocolType.Hls,
  )

  return {
    dashUri: dashManifest?.uris?.[0]?.uri,
    hlsUri: hlsManifest?.uris?.[0]?.uri,
  }
}
